<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { IconType } from '$shared/constants/IconType';
  import CustomCreate from './CustomCreate.svelte';

  interface Props {
    filteredList?: any;
    highlightedIndex?: number;
    listId?: string;
    canCreate?: boolean;
    createLabel?: string;
    value?: string;
    isEditable?: boolean;
    showRequiredInfo?: boolean;
    showCreateInfo?: boolean;
    infoLabel?: string;
    oniconClick?: (item: any) => void;
    onclickCreate?: () => void;
    onclickListItem?: (item: any) => void;
  }

  let {
    filteredList = [],
    highlightedIndex = -1,
    listId = '',
    canCreate = false,
    createLabel = '',
    value = '',
    isEditable = false,
    showRequiredInfo = false,
    showCreateInfo = false,
    infoLabel = '',
    oniconClick,
    onclickCreate,
    onclickListItem
  }: Props = $props();

  let isValueMatch = $derived(
    showCreateInfo ? !!filteredList.find((item) => item.label === value) : false
  );

  const onIconClick = (item): void => {
    oniconClick?.(item);
  };

  const onClickCreate = (): void => {
    onclickCreate?.();
  };

  const onClickListItem = (item): void => {
    onclickListItem?.(item);
  };
</script>

<div class="comp-autocomplete-list" role="listbox" id={listId}>
  {#if canCreate && createLabel && !value}
    <div class="create-label">{`Type to ${createLabel.toLowerCase()}`}</div>
  {/if}
  {#if showRequiredInfo && infoLabel}
    <div class="create-label">{infoLabel}</div>
  {:else}
    {#each filteredList as item, index}
      <button
        type="button"
        class="list-item"
        class:highlighted={index === highlightedIndex}
        data-nav-index={index}
        id={`${listId}-opt-${index}`}
        role="option"
        aria-selected={index === highlightedIndex}
        onclick={() => onClickListItem(item)}
        disabled={item.disabled}
      >
        <div class="list-label">
          <div class="label">{item.label}</div>
          {#if isEditable}
            <div class="edit-icon">
              <Icon
                name="edit-icon"
                type={IconType.Button}
                value="icon-edit-custom"
                onclick={() => onIconClick(item)}
              />
            </div>
          {/if}
        </div>
      </button>
    {:else}
      {#if !canCreate}
        <div class="empty">No data found</div>
      {/if}
    {/each}
    {#if canCreate && (filteredList.length === 0 || (showCreateInfo && !isValueMatch))}
      <CustomCreate
        {value}
        label={createLabel || infoLabel}
        navIndex={filteredList.length}
        optionId={`${listId}-opt-${filteredList.length}`}
        highlighted={filteredList.length === highlightedIndex}
        onclick={onClickCreate}
      />
    {/if}
  {/if}
</div>

<style>
  .list-item {
    text-align: left;
    display: flex;
    align-items: center;
    text-align: left;
    padding: 8px;
    width: 100%;
    font-weight: 600;
    font-size: 14px;
    color: var(--grey-dark);
  }
  .list-item:disabled {
    background-color: var(--grey-bg);
    color: var(--grey-medium);
  }
  .list-item:hover {
    background-color: var(--grey-bg);
  }
  /* Keyboard highlight is deliberately distinct from :hover. */
  .list-item.highlighted {
    background-color: var(--light-blue);
  }
  .list-item .list-label {
    flex: 1;
    display: flex;
    justify-content: space-between;
  }
  .list-item:hover .edit-icon {
    visibility: visible;
  }
  .edit-icon:not(:hover) {
    visibility: hidden;
  }
  .create-label {
    text-align: left;
    display: flex;
    align-items: center;
    text-align: left;
    padding: 8px;
    width: 100%;
    font-weight: 600;
    font-size: 14px;
    color: var(--grey-dark);
  }
  .empty {
    background-color: var(--grey-bg);
    line-height: 30px;
    padding: 0 8px;
    color: var(--grey-light);
  }
  .create-label {
    color: var(--grey-light);
  }
</style>
